import { render, staticRenderFns } from "./PlatformsRadioGroup.vue?vue&type=template&id=65b5ef52&scoped=true"
import script from "./PlatformsRadioGroup.vue?vue&type=script&lang=js"
export * from "./PlatformsRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./PlatformsRadioGroup.vue?vue&type=style&index=0&id=65b5ef52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5ef52",
  null
  
)

export default component.exports